import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import Currency from '../../../../helpers/currency.js'
import { ResponsiveRow, ResponsiveColumn } from '../../../ui/CustomResponsiveLayout'

@inject("currency")
@inject("store")
@observer
export default class Statistics extends React.Component {
  static propTypes = {
    currency: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  }

  get totalRevenue() {
    return this.totalAmountPaid + this.totalProjected + this.totalPastDue
  }

  get totalAmountPaid() {
    const { store } = this.props
    const { data } = store

    return data
      .map(period => period.amountPaidCents)
      .reduce((acc, value) => acc + value, 0)
  }

  get totalProjected() {
    const { store } = this.props
    const { data } = store

    return data
      .map(period => period.projectedCents)
      .reduce((acc, value) => acc + value, 0)
  }

  get totalPastDue() {
    const { store } = this.props
    const { data } = store

    return data
      .map(period => period.pastDueCents)
      .reduce((acc, value) => acc + value, 0)
  }

  get totalPostponed() {
    const { store } = this.props
    const { data } = store

    return data
      .map(period => period.postponedCents)
      .reduce((acc, value) => acc + value, 0)
  }

  get pricePerBooking() {
    if(this.eventCount == 0 || this.totalRevenue == 0) {
      return 0
    }

    return this.totalRevenue / this.eventCount
  }

  get eventCount() {
    const { store } = this.props
    const { data } = store

    return data
      .map(period => period.eventCount)
      .reduce((acc, value) => acc + value, 0)
  }

  render() {
    const { currency, store } = this.props
    const { data } = store

    const { totalRevenue, totalAmountPaid, totalProjected, totalPastDue, totalPostponed, eventCount, pricePerBooking } = this

    if(!data || !totalRevenue) {
      return null
    }

    return (
      <div className="statistics">
        <ResponsiveRow breakpoint={500}>
          <ResponsiveColumn className="text-center">
            Total Revenue: <span className="value">{ Currency.formatted(totalRevenue, currency)}</span>
          </ResponsiveColumn>
          <ResponsiveColumn className="text-center">
            Past Due: <span className="value">{ Currency.formatted(totalPastDue, currency)}</span>
          </ResponsiveColumn>
        </ResponsiveRow>
        <ResponsiveRow breakpoint={500}>
          <ResponsiveColumn className="text-center">
            Amount Paid: <span className="value">{ Currency.formatted(totalAmountPaid, currency)}</span>
          </ResponsiveColumn>
          <ResponsiveColumn className="text-center">
            Postponed: <span className="value">{ Currency.formatted(totalPostponed, currency)}</span>
          </ResponsiveColumn>
        </ResponsiveRow>
        <ResponsiveRow breakpoint={500}>
          <ResponsiveColumn className="text-center">
            Projected Revenue: <span className="value">{ Currency.formatted(totalProjected, currency)}</span>
          </ResponsiveColumn>
          <ResponsiveColumn className="text-center">
            Average per Booking: <span className="value">{ Currency.formatted(pricePerBooking, currency) }</span>
          </ResponsiveColumn>
        </ResponsiveRow>

        <ResponsiveRow breakpoint={500}>
          <ResponsiveColumn className="text-center">
            Booking Count: <span className="value">{ eventCount }</span>
          </ResponsiveColumn>
        </ResponsiveRow>
      </div>
    )
  }
}




